"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _TIME_LABEL = _interopRequireDefault(require("../../../constants/date/TIME_LABEL"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns the arabic AM PM label eg: 10:30 AM into 10:30 صباحا
 * @param {String} value
 * @returns {String}
 */
function getArabicAmPM(value) {
  var index = value.lastIndexOf(' ');
  var label = value.slice(index + 1);
  var time = '';
  if (_TIME_LABEL["default"].AM.EN === label) {
    time = _TIME_LABEL["default"].AM.AR;
  }
  if (_TIME_LABEL["default"].PM.EN === label) {
    time = _TIME_LABEL["default"].PM.AR;
  }
  if (_TIME_LABEL["default"].HOURS.EN === label) {
    time = _TIME_LABEL["default"].HOURS.AR;
  }
  return value.replace(label, time);
}
var _default = exports["default"] = getArabicAmPM;